export default "__VITE_ASSET__dZz7oLUF__"